<svg style="background:var(--anatomy-gray-100);" height="152" viewBox="0 0 192.002 192">
  <defs>
    <linearGradient id="linear-gradient" x2="1" gradientUnits="objectBoundingBox">
      <stop offset="0" stop-color="var(--anatomy-gray-300)"/>
      <stop offset="1" stop-color="var(--anatomy-gray-500)"/>
    </linearGradient>
  </defs>
  <g id="Color_wheel" data-name="Color wheel" transform="scale(.95) translate(5 5)">
    <path id="Path_17" data-name="Path 17" d="M96,192a96.706,96.706,0,0,1-19.347-1.95,95.968,95.968,0,0,1-74.7-74.7,96.935,96.935,0,0,1,0-38.7,95.97,95.97,0,0,1,74.7-74.7,96.935,96.935,0,0,1,38.7,0,95.977,95.977,0,0,1,74.7,74.707,96.935,96.935,0,0,1,0,38.695,95.968,95.968,0,0,1-74.7,74.7A96.707,96.707,0,0,1,96,192ZM96,24a71.881,71.881,0,1,0,28.022,5.658A71.664,71.664,0,0,0,96,24Z" fill="url(#linear-gradient)"/>
    <g id="Ellipse_3" data-name="Ellipse 3" transform="translate(0 -0.001)" fill="var(--anatomy-gray-800)" fill-opacity="0" stroke="var(--anatomy-gray-900)" stroke-opacity="0.1" stroke-width="1">
      <circle cx="96.001" cy="96.001" r="96.001" stroke="none"/>
      <circle cx="96.001" cy="96.001" r="95.501" fill="none"/>
    </g>
    <g id="Ellipse_4" data-name="Ellipse 4" transform="translate(23 22.999)" fill="var(--anatomy-gray-800)" fill-opacity="0" stroke="var(--anatomy-gray-900)" stroke-opacity="0.1" stroke-width="1">
      <circle cx="73.001" cy="73.001" r="73.001" stroke="none"/>
      <circle cx="73.001" cy="73.001" r="72.501" fill="none"/>
    </g>
    <g id="Handle">
      <g id="Handle_Ring" data-name="Handle Ring" transform="translate(147.398 28.603)" fill="var(--anatomy-gray-800)" fill-opacity="0" stroke="var(--anatomy-gray-50)" stroke-width="2">
        <circle cx="8" cy="8" r="8" stroke="none"/>
        <circle cx="8" cy="8" r="7" fill="none"/>
      </g>
      <g id="Handle_Border_Outside" data-name="Handle Border Outside" transform="translate(146.398 27.603)" fill="var(--anatomy-gray-800)" fill-opacity="0" stroke="var(--anatomy-gray-900)" stroke-opacity="0.42" stroke-width="1">
        <circle cx="9" cy="9" r="9" stroke="none"/>
        <circle cx="9" cy="9" r="8.5" fill="none"/>
      </g>
      <circle id="Handle_Fill" data-name="Handle Fill" cx="6" cy="6" r="6" transform="translate(149.398 30.603)" fill="var(--anatomy-gray-500)"/>
      <g id="Handle_Border_Inside" data-name="Handle Border Inside" transform="translate(149.398 30.603)" fill="var(--anatomy-gray-800)" fill-opacity="0" stroke="var(--anatomy-gray-900)" stroke-opacity="0.42" stroke-width="1">
        <circle cx="6" cy="6" r="6" stroke="none"/>
        <circle cx="6" cy="6" r="5.5" fill="none"/>
      </g>
    </g>
  </g>
</svg>
